<template>
  <div class="tips-wrapper" v-if="consejoTexto">
    <div class="tips-container">
      <!-- Ícono decorativo -->
      <div class="tips-icon-wrap">
        <span class="material-symbols-outlined tips-icon">lightbulb</span>
      </div>

      <!-- Etiqueta -->
      <div class="tips-label">Consejo del sistema</div>

      <!-- Texto -->
      <p class="tips-texto" :class="{ 'tips-texto--cargando': cargando }">
        <span v-if="cargando" class="tips-skeleton"></span>
        <span v-else>{{ consejoTexto }}</span>
      </p>

      <!-- Botón refrescar -->
      <button class="tips-refresh" @click="fetchConsejo" :disabled="cargando" title="Nuevo consejo">
        <span class="material-symbols-outlined" :class="{ 'tips-spin': cargando }" style="font-size:16px">
          refresh
        </span>
      </button>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'

export default {
  name: 'Tips',
  data() {
    return {
      consejoTexto: '',
      cargando:     false,
    }
  },
  methods: {
    async fetchConsejo() {
      this.cargando = true
      try {
        const response   = await api.get('/vwconsperfs/tips/random/5')
        this.consejoTexto = response.data.consejoTexto
      } catch (error) {
        console.error('Error al obtener el consejo:', error)
        this.consejoTexto = 'Recuerda guardar tu trabajo frecuentemente.'
      } finally {
        this.cargando = false
      }
    },
  },
  mounted() {
    this.fetchConsejo()
  },
}
</script>

<style scoped>
.tips-wrapper {
  margin: 12px 0;
}

.tips-container {
  position: relative;
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 14px 16px 14px 14px;
  border-radius: 10px;
  border-left: 4px solid #f5c400;
  background: linear-gradient(135deg, #fffdf0 0%, #fff8d6 100%);
  box-shadow: 0 2px 8px rgba(245, 196, 0, .15);
}

.tips-icon-wrap {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #f5c400;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-top: 2px;
}
.tips-icon {
  font-size: 20px;
  color: #fff;
}

.tips-label {
  position: absolute;
  top: -10px;
  left: 54px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: #92400e;
  background: #fef3c7;
  border: 1px solid #fcd34d;
  border-radius: 4px;
  padding: 1px 6px;
}

.tips-texto {
  font-size: .9rem;
  color: #3a3a3a;
  line-height: 1.6;
  margin: 0;
  padding-top: 4px;
  flex: 1;
}

/* Skeleton mientras carga */
.tips-skeleton {
  display: block;
  height: 14px;
  background: linear-gradient(90deg, #fde68a 25%, #fef3c7 50%, #fde68a 75%);
  background-size: 200% 100%;
  border-radius: 4px;
  animation: shimmer 1.5s infinite;
  width: 85%;
}
@keyframes shimmer {
  0%   { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* Botón refrescar */
.tips-refresh {
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  color: #92400e;
  opacity: .5;
  padding: 2px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  transition: opacity .2s, background .2s;
}
.tips-refresh:hover:not(:disabled) {
  opacity: 1;
  background: rgba(245, 196, 0, .2);
}
.tips-refresh:disabled { cursor: default; }

@keyframes spin {
  from { transform: rotate(0deg); }
  to   { transform: rotate(360deg); }
}
.tips-spin { animation: spin .7s linear infinite; }
</style>